import { type MaterialSapVo } from "@/apis/sap.api";
import SelectMaterialModal from "@/components/SelectMaterialModal";
import { Button, Col, Form, Input, Row } from "antd";
import { useState } from "react";

type Props = {
  /** 选择完成后的回调 */
  onSelect?: (materials?: MaterialSapVo[]) => void;
};

const MaterialSelector: React.FC<Props> = ({ onSelect }) => {
  const [materialCode, setMaterialCode] = useState("");
  const [modalOpen, setModalOpen] = useState(false);

  const handleOpenModal = () => {
    if (!materialCode.trim()) {
      // 如果没有填写物料编号，直接打开弹窗，不传初始参数
      setModalOpen(true);
      return;
    }
    // 传入物料编号作为初始过滤条件
    setModalOpen(true);
  };

  const handleOk = (materials?: MaterialSapVo[]) => {
    setModalOpen(false);
    if (materials && materials.length > 0) {
      onSelect?.(materials);
    }
  };

  return (
    <>
      <Form size="middle" style={{ marginBottom: 20 }}>
        <Row gutter={42}>
          <Col span={8}>
            <Row gutter={20}>
              <Col span={16}>
                <Input
                  placeholder="请输入物料编号"
                  value={materialCode}
                  onChange={(e) => setMaterialCode(e.target.value)}
                  allowClear
                />
              </Col>
              <Col span={8}>
                <Button type="primary" onClick={handleOpenModal}>
                  获取物料
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </Form>
      <SelectMaterialModal
        open={modalOpen}
        onOk={handleOk}
        onClose={() => setModalOpen(false)}
        initialParams={
          materialCode.trim() ? { f101: materialCode.trim() } : undefined
        }
      />
    </>
  );
};

export default MaterialSelector;
